import { gql } from '@apollo/client'
import { CHATBOT_CONVERSATION_FIELDS } from './fragments/chatbot_conversation'

export const OPEN_CHATBOT_REPORT_CONVERSATION = gql`
  ${CHATBOT_CONVERSATION_FIELDS}
  mutation openChatbotReportConversation($reportId: ID!) {
    openChatbotReportConversation(reportId: $reportId) {
      ...ChatbotConversationFields
    }
  }
`
